export const DEFAULT_ONE_OF_TYPE = "type"
export const DEFAULT_ONE_OF_VALUE = "value"
